import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.flexColumn,
  paddingBottom: 5,
}));

export const FlightTitle = styled("div")(({ theme, isOrange }) => ({
  paddingLeft: 10,
  height: 34,
  lineHeight: "34px",
  overflow: "hidden",
  color: isOrange ? theme.palette.accent.redLight : theme.palette.text.primary,
  backgroundColor: "transparent",
  fontSize: 15,
  fontWeight: 600,
}));

export const FlightsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
}));

export const InfoWrapper = styled("div")(({ theme }) => ({
  ...theme.paddings(16, 20),
  ...theme.margins(0, 10),
  display: "flex",
  gap: 20,
  backgroundColor: theme.palette.fly.segmentBg,
  borderRadius: 8,

  [theme.down("sm")]: {
    flexWrap: "wrap",
    justifyContent: "space-between",
    ...theme.paddings(12, 12),
    ...theme.margins(0, 0),
  },
}));

export const AirlineAndSitsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "center",
  gap: 5,
  width: 90,

  [theme.down("sm")]: {
    width: "auto",
  },
}));

export const SitsCount = styled("div")(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 11,
}));

export const AirlineLogo = styled("img")(({ theme }) => ({
  width: 90,
  height: 30,
  objectFit: "contain",
}));

export const FlightNumbersBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "center",
  justifyContent: "center",
  gap: 5,
  width: 60,

  [theme.down("sm")]: {
    width: "auto",
  },
}));

export const FlightNumber = styled("div")(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: 13,
  lineHeight: 1,
}));

export const FlightTimingsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  justifyContent: "space-between",
  flexGrow: 1,
  gap: 30,

  [theme.down("sm")]: {
    width: "100%",
    gap: 20,
  },
}));

export const DepartureBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  color: theme.palette.text.primary,

  "& > span.airport": {
    fontSize: 13,
    lineHeight: "14px",
  },

  "& > span.time": {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: "26px",
  },

  "& > span.date": {
    fontSize: 12,
    lineHeight: "14px",
  },
}));

export const DurationBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,
  gap: 5,

  "& > div.duration-time": {
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: 600,
    textAlign: "center",
  },

  "& > div.flight-line": {
    ...theme.mixins.flexAlignCenter,
    borderRadius: 2.5,
    height: 5,

    "& > div": {
      backgroundColor: theme.palette.flight.routeLine,
      borderRadius: 2,
      margin: "0 1px",

      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        cursor: "default",
      },
    },
  },

  "& > div.segments": {
    fontSize: 11,
    fontWeight: 600,
    color: theme.palette.text.primary,
    textAlign: "center",
  },
}));

export const ArrivalBlock = styled(DepartureBlock)(({ theme }) => ({
  textAlign: "right",
}));

export const DetailsAndRulesBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "relative",
  height: 33,
  paddingTop: 10,
  paddingBottom: 5,
}));

export const DetailsButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 4,
  border: "none",
  backgroundColor: "transparent",
  color: theme.palette.text.primary,
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1,
  cursor: "pointer",

  "& > span": {
    fontSize: 12,
    lineHeight: 1,
    transition: "transform .3s ease",
  },

  "& > span.active": {
    transform: "rotate(90deg)",
  },
}));

export const RulesButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  right: 10,
  bottom: 5,
  fontSize: 10,
  border: "none",
  backgroundColor: "transparent",
  cursor: "pointer",

  "& > span": {
    fontSize: 10,
    lineHeight: 1,
  },

  "& > span.active": {
    transform: "rotate(90deg)",
  },
}));

export const FlightDetails = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
  padding: 16,
  margin: "8px 10px 0",
  backgroundColor: theme.palette.white,
  border: `1px solid ${theme.palette.fly.brandBorder}`,
  borderRadius: 8,

  [theme.down("sm")]: {
    margin: "8px 0 0",
    padding: 12,
  },
}));

export const FlightSegment = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: 25,
  backgroundColor: theme.palette.white,
  padding: "12px 0",
  color: theme.palette.text.primary,
  fontSize: 12,

  [theme.down("sm")]: {
    flexWrap: "wrap",
  },

  "& > .flightInfo": {
    flexGrow: 1,

    [theme.down("sm")]: {
      order: 3,
      width: "100%",
    },
  },

  "& > .baggageCabinInfo": {
    textTransform: "capitalize",
    minWidth: 80,
    textAlign: "center",

    [theme.down("sm")]: {
      order: 2,
    },
  },
}));

export const FlightSegmentTimeAircraft = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 10,

  "& > .flightAndDuration": {
    ...theme.mixins.flexAlignCenter,
    gap: 10,

    "& > .duration": {
      fontSize: 10,
    },
  },
}));

export const FlightSegmentTimings = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 20,
  width: "100%",

  "& > .flightTime": {
    color: theme.palette.text.primary,
    fontSize: 14,

    "& > span": {
      color: theme.palette.text.muted,
      fontSize: 12,
      paddingLeft: 5,
    },
  },

  "& > .flightPlace": {
    display: "flex",
    gap: 10,

    "& > .flightPlaceCode": {
      fontSize: 12,
      color: theme.palette.text.primary,
      textTransform: "uppercase",
    },

    "& > .flightPlaceName": {
      ...theme.mixins.flexColumn,

      "& > span": {
        color: theme.palette.text.muted,
        fontSize: 12,
        lineHeight: "20px",
      },
    },
  },
}));

export const FlightSegmentIcons = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 3,
  paddingTop: 5,
  fontSize: 20,
  lineHeight: 1,
  color: theme.palette.primary.dark,

  "& .hasNotBaggage": {
    color: theme.palette.error.dark,
  },
}));

export const TransferBlock = styled("div")(({ theme }) => ({
  padding: "8px 12px",
  backgroundColor: theme.palette.flight.layoverBg,
  borderRadius: 8,
}));

export const TransferTime = styled("div")(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: 13,
  fontWeight: 600,
}));

export const CharterBadge = styled("div")(({ theme }) => ({
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: 4,
  fontSize: 11,
  fontWeight: 500,
  background: "#e8f5e9",
  border: "1px solid #a5d6a7",
  color: "#2e7d32",
}));
